import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef, ViewChild, AfterContentChecked } from '@angular/core';
import * as _ from 'underscore';
import * as jQuery from 'jquery';

import { WidgetCore } from '../../interfaces/widget.core.interface';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { NetworkDetail } from '../creative-detail-v2/creative-detail.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { CreativePerformanceV1Component } from '../creative-performace-v1/creative-performance-v1.component';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { DataTableConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';

@Component({
	selector: 'app-network-and-shows-r5',
	templateUrl: './network-and-shows-r5.component.html',
	styleUrls: ['./network-and-shows-r5.component.css']
})
export class NetworkAndShowsR5Component extends CreativePerformanceV1Component
	implements OnInit, WidgetCore, OnDestroy, AfterContentChecked {
	@ViewChild('carousel') carousel: any;
	options = {
		clicking: true,
		sourceProp: '',
		visible: 9,
		perspective: 1,
		startSlide: 4,
		border: 3,
		dir: 'rtl',
		width: 300,
		height: 300,
		space: 200,
		loop: true,
		autoRotationSpeed: 6000000,
		autoRotationLocked: true
	};

	showLoad = false;
	showTableLoad = false;
	reorderable = false;

	public downloadConfiguration: DownloadConfig;
	public selectedLegend;
	public tableConfig: DataTableConfig = <DataTableConfig>{};
	public dataTableObj: any = { data: [], columns: [] };
	public carouselLoadFlag: boolean = false;
	public sortedNetworks: NetworkDetail[] = [];
	public networks: NetworkDetail[] = [];
	public currentNetworkData: any;
	public cssClasses: any = {
		sortAscending: 'datatable-icon-down',
		sortDescending: 'datatable-icon-up',
		pagerLeftArrow: 'datatable-icon-left',
		pagerRightArrow: 'datatable-icon-right',
		pagerPrevious: 'datatable-icon-prev',
		pagerNext: 'datatable-icon-skip'
	};

	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrow: true,
		duration: 750,
		scale: 'big',
		dynamicTitle: true
	};

	public footerHeight;
	public reloadSubscription;
	public widgetDataSubscription;
	public hasData = false;

	@Input() sectiontitle: string;
	@Input() downloadconfig: string;
	@Input() legend: any;
	@Input() datatableconfig;
	@Input() isVerticalScrollable;
	@Input() rowHeight;
	@Input() isTotalCalc;
	@Input() isClickable;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
	}

	ngAfterContentChecked() {
		// rebuild carousel when there is a change in networks array using the flag `carouselLoadFlag`
		if (this.carousel && this.carouselLoadFlag) {
			this.carousel.currentIndex = this.selectedIndex;
			this.options.startSlide = this.selectedIndex;
			this.carousel.buildCarousel(this.sortedNetworks, this.options);
			this.carouselLoadFlag = false;
		}
		// center align the carousel images
		jQuery('.carousel-3d').css({
			'margin-top': '2%'
		});
		jQuery('.carousel-3d-container').css({
			height: '360px'
		});
		let divWidth = jQuery('.network-logo-div').width();
		jQuery('.network-logo-name').map(function () {
			let fontSize = (divWidth * 0.1) / jQuery(this).text().length;
			let finalSize = fontSize <= 20 ? fontSize + 0.3 : 20;
			jQuery(this).css({ 'font-size': finalSize + 'em' });
		});
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
	}

	ngOnInit() {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.legend = JSON.parse(decodeURI(this.legend));
		if (typeof this.datatableconfig === 'string') {
			this.tableConfig = JSON.parse(decodeURI(this.datatableconfig));
		} else {
			this.tableConfig = this.datatableconfig;
		}
		this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
		this.footerHeight = this.isVerticalScrollable ? 0 : 50;
		this.rowHeight = this.rowHeight ? this.rowHeight : 'auto';
		this.processLegendData();
		this.requestData();
	}

	/**
	 * Generate column config for data table
	 */
	protected generateColumnConfigurationForDataTable() {
		const columnsConfig = this.tableConfig.columns;
		const sortedColumnConfig = _.sortBy(columnsConfig, 'columnOrder');
		const columns = [];
		for (const colConfig of sortedColumnConfig) {
			const colObj: any = <any>{};
			colObj.name = colConfig.columnName;
			colObj.prop = colConfig.columnType === 'number' ? 'formatted_' + colConfig.columnKey : colConfig.columnKey;
			colObj.headerClass = colConfig.columnHeaderClass;
			colObj.cellClass = colConfig.columnCellClass;
			colObj.hasProgressBar = colConfig.columnHasProgressBar;
			colObj.showTitle = colConfig.columnShowTitle;
			colObj.columnKey = colConfig.columnKey;
			if (colConfig.columnType === 'number') {
				colObj.comparator = this.comparator.bind(this, colConfig.columnKey);
			}
			colObj.resizeable = false;
			colObj.columnHasTooltip = colConfig.columnHasTooltip;
			colObj.columnTooltip = colConfig.columnTooltip;
			columns.push(colObj);
		}
		return columns;
	}

	/**
	 * Get the response from API request
	 */
	requestData() {
		this.hasGraphData = false;
		this.showLoad = true;
		this.hasData = true;
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			this.dataTableObj.data = [];
			if (response.success) {
				this.hasData = true;
				this.responseData = response.data;
				this.processResponseData(response.data);
				this.carouselLoadFlag = true;
			} else {
				this.hasData = false;
				this.showLoad = false;
				this.dataTableObj.data = [];
			}
		});
	}

	/**
	 * Get the airings data for given network
	 */
	requestfeaturedNetworkData(networkId) {
		this.hasGraphData = false;
		this.showTableLoad = true;
		this.hasData = true;
		this.analyticsService.getNetworkData(this.tertiarykey, networkId).subscribe((response: any) => {
			this.showTableLoad = false;
			this.dataTableObj.data = [];
			if (response.success) {
				this.hasData = true;
				this.dataTableObj.data = response.data;
				this.sortedNetworks[this.selectedIndex].showsByDates = response.data;
				this.carouselLoadFlag = true;
			} else {
				this.hasData = false;
				this.showTableLoad = false;
				this.dataTableObj.data = [];
			}
		});
	}

	/**
	 * Process the API response data
	 * @param responseData array
	 */
	processResponseData(responseData) {
		if (responseData.length > 0) {
			this.hasData = true;
			this.networks = this.mapResponseDataToInterfaceNetwork(responseData);
			this.selectedLegend = _.findWhere(this.legend, { selected: true });
			this.graphData = this.generateCarouselDataBySelection(this.selectedLegend.value);
			this.hasGraphData = true;
		} else {
			this.hasData = false;
		}
	}

	/**
	 * map the API response data to mapped response einterface
	 * @param legendItem string
	 */
	protected mapResponseDataToInterfaceNetwork(responseData) {
		const networkPerformances: NetworkDetail[] = [];
		for (const response of responseData) {
			const networkObj: NetworkDetail = <NetworkDetail>{};
			networkObj.networkName = response.network_name
				? response.network_name
				: response.name
				? response.name
				: response.ad_headline;
			networkObj.airings = UtilityService.isUndefinedOrNull(response.airings) ? 0 : parseFloat(response.airings);

			if (response.url) {
				networkObj.url = response.url;
			}
			networkObj.description = response.description;
			networkObj.networkLogo = response.thumbnail_url ? response.thumbnail_url : '';
			networkObj.showsByDates = [];
			networkObj.networkId = response.network_id;
			networkPerformances.push(networkObj);
		}
		return networkPerformances;
	}

	/**
	 * Sort the carousel items by given parameter
	 * @param legendItem string
	 */
	protected sortNetworksBySelection(selectionItem: string) {
		const sortedNetworks = _.sortBy(this.networks, selectionItem).reverse();
		return sortedNetworks;
	}

	/**
	 * Generate the carousel data
	 * @param selectionItem string
	 */
	protected generateCarouselDataBySelection(selectionItem) {
		const sortedNetworks = this.sortNetworksBySelection(selectionItem);
		this.sortedNetworks = _.compact(sortedNetworks);
		this.selectedIndex = this.sortedNetworks.length < 9 ? Math.floor(this.sortedNetworks.length / 2) : 4;
		this.currentNetworkData = JSON.parse(JSON.stringify(this.sortedNetworks[this.selectedIndex]));
		this.requestfeaturedNetworkData(this.sortedNetworks[this.selectedIndex].networkId);
		return this.currentNetworkData;
	}

	/**
	 * Generate a CSV with all the details of the networks and shows widget
	 * @param event event
	 */
	downloadDataInCSV(event: any) {
		event.preventDefault();
		this.analyticsService.downloadCSV(this.downloadConfiguration.csvQueryKey, this.downloadConfiguration.fileName);
	}

	/**
	 * Generate the new Carousel data slide when clicked
	 * @param index - index of carousel
	 */
	slideClicked(index) {
		this.carousel.slideClicked(index);
		this.selectedIndex = index;
		this.currentNetworkData = JSON.parse(JSON.stringify(this.sortedNetworks[this.selectedIndex]));
		if (!this.sortedNetworks[this.selectedIndex].showsByDates.length) {
			this.requestfeaturedNetworkData(this.sortedNetworks[this.selectedIndex].networkId);
		} else {
			this.dataTableObj.data = this.sortedNetworks[this.selectedIndex].showsByDates;
		}
	}

	/**
	 * Generate the new Carousel data slide when slided left
	 */
	slideLeft() {
		if (this.selectedIndex === 0) {
			this.selectedIndex = this.sortedNetworks.length - 1;
		} else {
			this.selectedIndex--;
		}
		this.slideClicked(this.selectedIndex);
	}

	/**
	 * Generate the new Carousel data slide when slided right
	 */
	slideRight() {
		if (this.selectedIndex === this.sortedNetworks.length - 1) {
			this.selectedIndex = 0;
		} else {
			this.selectedIndex++;
		}
		this.slideClicked(this.selectedIndex);
	}

	comparator(propertyName, a, b, c, d) {
		if (parseFloat(c[propertyName]) < parseFloat(d[propertyName])) {
			return 1;
		}
		if (parseFloat(c[propertyName]) > parseFloat(d[propertyName])) {
			return -1;
		}
	}
}
